import React, { Component } from "react";
import {
  updateLoggedInUser,
  setAvailableLanguages,
  selectLanguage,
  fetchWordListThunk,
  articlesNeedReload,
  updateArticles,
} from "../../redux/actions";
import { connect } from "react-redux";
import getFlagImageName from "../../scripts/getFlagImageName";
import { isMobile } from "react-device-detect";

class FullScreenLanguageSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alreadyShown: false,
      show: false,
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (this.props.loggedInUser && !this.state.alreadyShown && !this.state.show && !this.props.loggedInUser.currentLanguage) {
      this.setState({
        show: true,
        alreadyShown: true,
      });
    }
  }

  onSelectionComplete = (language) => {
    language = language.toLowerCase();
    fetch("/user/setlanguage/" + language, {
      method: "get",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "cache-control": "no-cache",
      },
    })
      .then((result) => result.json())
      .then((result) => {
        this.props.selectLanguage(language);
        this.props.fetchWordListThunk(language);
        this.reloadArticles();
        if (window.location.pathname.includes("/read-story")) {
          window.location.href = "/stories";
        }
      });
    this.setState({ show: false });
  };

  reloadArticles = () => {
    let route = this.props.loggedInUser ? "/article/getall" : "/article/getallfree";
    fetch(route, {
      method: "get",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "cache-control": "no-cache",
      },
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.status == "success") {
          this.props.updateArticles(result.articles, result.categories);
          this.props.articlesNeedReload(false);
        } else {
          if (!isMobile) alert("could not get articles. check your internet connection");
        }
      });
  };

  render() {
    if (!this.state.show) {
      return null;
    }

    let languages = this.props.availableLanguages || [];
    languages = languages.filter((l) => (l.isActive ? true : false));

    return (
      <div style={styles.cover}>
        <div style={styles.content}>
          <h1 style={styles.title}>Select a Language</h1>
          <p style={styles.subtitle}>Choose a language to get started</p>
          <div style={styles.languageGrid}>
            {languages.map((language, index) => {
              const flagName = getFlagImageName(language.title);
              let flagImage = null;

              try {
                if (flagName) {
                  flagImage = require(`../../assets/img/flags/${flagName}.png`);
                }
              } catch (e) {
                console.warn(`Flag image not found for ${language.title}`);
              }

              return (
                <div
                  key={index}
                  style={styles.languageCard}
                  onClick={() => this.onSelectionComplete(language.title)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                  }}
                >
                  {flagImage && <img src={flagImage} alt={language.title} style={styles.flagImage} />}
                  <h3 style={styles.languageTitle}>{language.title.charAt(0).toUpperCase() + language.title.slice(1)}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  cover: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.85)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "20px",
  },
  content: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: isMobile ? "20px" : "40px",
    maxWidth: isMobile ? "600px" : "900px",
    width: "100%",
    maxHeight: "90vh",
    overflowY: "auto",
    boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
  },
  title: {
    fontSize: isMobile ? "24px" : "32px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: isMobile ? "8px" : "10px",
    color: "#333",
  },
  subtitle: {
    fontSize: isMobile ? "14px" : "16px",
    textAlign: "center",
    color: "#666",
    marginBottom: isMobile ? "20px" : "40px",
  },
  languageGrid: {
    display: "grid",
    gridTemplateColumns: isMobile ? "repeat(auto-fill, minmax(120px, 1fr))" : "repeat(auto-fill, minmax(200px, 1fr))",
    gap: isMobile ? "12px" : "20px",
    padding: isMobile ? "5px" : "10px",
  },
  languageCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: isMobile ? "15px 10px" : "30px 20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    border: "2px solid transparent",
  },
  flagImage: {
    width: isMobile ? "50px" : "80px",
    height: isMobile ? "38px" : "60px",
    objectFit: "contain",
    marginBottom: isMobile ? "10px" : "15px",
    display: "block",
  },
  languageTitle: {
    fontSize: isMobile ? "14px" : "18px",
    fontWeight: "600",
    color: "#333",
    margin: 0,
    textAlign: "center",
  },
};

const mapStateToProps = (state) => ({
  loggedInUser: state.loggedInUser,
  availableLanguages: state.availableLanguages,
  podcastMeta: state.podcastMeta,
});

const mapActionsToProps = {
  onUpdateLoggedInUser: updateLoggedInUser, //to prevent variable collisions with naming, use on
  onSetAvailableLanguages: setAvailableLanguages,
  selectLanguage,
  updateArticles,
  articlesNeedReload,
  fetchWordListThunk,
};

export default connect(mapStateToProps, mapActionsToProps)(FullScreenLanguageSelect);
